import React, { PureComponent } from 'react';
import { Row, Col, UncontrolledPopover, PopoverHeader, PopoverBody } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { string } from 'prop-types';
import { STATIC_PATH } from '../../../../config';
import { FMessage } from '../../../../hoc/IntlComponents';
import { getStoreUrl } from '../../../../utils/utils';
import OfferCardItem from '../../../../components/Offer/OfferCardItem';
import OfferCardStats from './OfferCardStats';
import OfferCardStatsDating from "./OfferCardStatsDating";

class OfferCardInfo extends PureComponent {
  static propTypes = {
    title: string.isRequired,
    url: string,
    pic: string,
  };

  state = {
    popoverOpen: false,
    coinsTooltipOpen: false,
  };

  renderCoinTooltip = ({ id, target, coins }) => {
    return (
      <UncontrolledPopover
        trigger="hover"
        className="offer-coins-popover"
        placement="left"
        target={`${target}-${id}`}
      >
        <PopoverHeader>
          {' '}
          <b>
            <FMessage id="offer.tooltip.header" />
          </b>
        </PopoverHeader>
        <PopoverBody>
          {' '}
          <div>
            <FormattedMessage
              id="offer.tooltip.p"
              defaultMessage="According to this offer,  {coins, plural, one {# coin} other {# coins} } is charged for a confirmed application. Coins you can spend on "
              values={{
                coins,
              }}
            />
            <a href={getStoreUrl()} target="_blank">
              <FMessage id="offer.tooltip.link-to-store" />
            </a>
          </div>
        </PopoverBody>
      </UncontrolledPopover>
    );
  };

  renderCoins = () => {
    const {
      modifies: { coins },
      id,
    } = this.props;
    if (coins === 1) {
      return (
        <div id={`coins-${coins}-${id}`} className={`coins-${coins}`}>
          <img src={`${STATIC_PATH}/img/coin-big.svg`} />
          {this.renderCoinTooltip({ id, target: `coins-${coins}`, coins })}
        </div>
      );
    } else if (coins === 2) {
      return (
        <div id={`coins-${coins}-${id}`} className={`coins-${coins}`}>
          <img src={`${STATIC_PATH}/img/coin-big.svg`} />
          <img src={`${STATIC_PATH}/img/coin-big.svg`} />
          {this.renderCoinTooltip({ id, target: `coins-${coins}`, coins })}
        </div>
      );
    }
    return null;
  };

  render() {
    const {
      title,
      url,
      pic,
      currencies,
      children,
      stats,
      description: { description, full_description },
      modifies,
    } = this.props;

    return (
      <Row className="offer-basic-info">
        <Col xs="6" md="2" sm="6" xl="2" lg="3">
          <div className="offer-pic">
            {pic && <img src={`${pic}?1`} className="rounded-circle" alt="" />}
            {this.renderCoins()}
          </div>
        </Col>

        {!modifies.g && !modifies.d && (
          <Col xs="6" md="3" sm="6" xl="3" lg="3">
            <OfferCardStats currencies={currencies} stats={stats} />
          </Col>
        )}

        {modifies.d && (
            <Col xs="6" md="3" sm="6" xl="3" lg="3">
              <OfferCardStatsDating currencies={currencies} stats={stats} />
            </Col>
        )}

        <Col xs="12" md="7" sm="12" xl="7" lg="6">
          {description && (
            <OfferCardItem
              id="offer.overview"
              className="offer-overview"
              defaultMessage="Overview"
              html={description}
            />
          )}

          {full_description && (
            <OfferCardItem
              id="offer.description"
              defaultMessage="Description"
              className="offer-description"
              html={full_description}
            />
          )}

          {url && (
            <a href={url} className="offer-link" target="_blank">
              {url}
            </a>
          )}

          {/* <h3 className="offer-title">{title}</h3>
                    {url && (
                        <a href={url} className="offer-link" target="_blank">
                            {url}
                        </a>
                    )}
                    {children} */}
        </Col>
      </Row>
    );
  }
}

export default OfferCardInfo;
